import { z } from 'zod';
import { CursorPaginationSchema } from '../../common';

export const GroupSchema = z.object({
    id: z.string(),
    name: z.string(),
    membership: z.discriminatedUnion('kind', [
        z.object({
            kind: z.literal('internal'),
            organization_id: z.number()
        }),
        z.object({
            kind: z.literal('opt_in'),
        }),
        
    ])
});

export const GroupListResponseSchema = z.object({
    data: z.array(GroupSchema),
    pagination: CursorPaginationSchema
});
